module.exports = __webpack_public_path__ + "img/969047efba85d6463b8bb361a4936805.png";